import { ref, onMounted, onBeforeUnmount } from 'vue';
import { emitter } from 'shared/helpers/mitt';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// SiteUp: liga a Central de Agendamento ao evento global 'agenda:quick:open'
// (emitido pelo card do Hub e pelo item Agenda do Modo Foco). O painel é
// montado uma vez no shell do dashboard e abre por cima de qualquer tela.
//
// A flag é conferida AQUI, não só em quem emite: o painel é montado para toda
// conta (Dashboard.vue, sem v-if), então um emissor futuro que esquecesse de
// checar abriria a Central inteira numa conta sem a feature.
export function useAgendaQuickPanel() {
  const open = ref(false);
  const { isFeatureFlagEnabled } = usePolicy();

  const onOpen = () => {
    if (!isFeatureFlagEnabled(FEATURE_FLAGS.AGENDA_CENTRAL)) return;
    open.value = true;
  };

  onMounted(() => emitter.on('agenda:quick:open', onOpen));
  onBeforeUnmount(() => emitter.off('agenda:quick:open', onOpen));

  return { open };
}
